import classNames from 'classnames';

const TableHeaderCell = ({
  children,
  extraClassNames,
  nowrap,
  mainCell,
  sortedBy,
  refactoring,
  style,
  ...rest
}) => {
  return (
    <th
      className={classNames('c-table-cell c-table-cell--header', {
        'c-table-cell--main': mainCell,
        'c-table-cell--nowrap': nowrap,
        'c-table-cell--sorted': sortedBy,
        'r-table-cell--header': refactoring
      })}
      style={style}
      {...rest}
    >
      <div className={classNames('o-flex', extraClassNames)}>{children}</div>
    </th>
  );
};

export default TableHeaderCell;
